export const REACT_APP_BACKEND_URL = globalThis?.env?.REACT_APP_BACKEND_URL as string
  || process.env?.REACT_APP_BACKEND_URL;


